<template>
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.7122" cy="21.7122" r="21.7122" fill="#1083b9" />
    <path
      d="M29.9989 13.4241L17.3629 23.6765L13.7178 18.4983C13.2138 17.7844 12.2328 17.6127 11.5218 18.1188C10.8108 18.6248 10.6443 19.6099 11.1438 20.3238L15.7609 26.8801C16.0129 27.237 16.3999 27.472 16.8319 27.5352C16.9039 27.5443 16.9759 27.5488 17.0479 27.5488C17.4079 27.5488 17.7544 27.4268 18.0379 27.1964L31.9834 15.8866C32.6584 15.3399 32.7664 14.3413 32.2174 13.6636C31.6684 12.9813 30.6784 12.8774 29.9989 13.4241Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "PartiallyCorrectRounded",
};
</script>
